import React from "react"

import { Button, Menu, MenuItem, ListItemText } from "@mui/material"

interface AddJobMenuProps {
  buttonLabel: string
  onAddJob: () => void
  onAddSuggestedJobs: () => void
  addJobLabel?: string
  addSuggestedLabel?: string
}

const AddJobMenu: React.FC<AddJobMenuProps> = ({
  buttonLabel,
  onAddJob,
  onAddSuggestedJobs,
  addJobLabel,
  addSuggestedLabel,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const menuId = React.useId()

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => setAnchorEl(null)

  return (
    <>
      <Button
        sx={{ whiteSpace: "nowrap" }}
        onClick={handleButtonClick}
        aria-haspopup="true"
        aria-expanded={open}
        aria-controls={open ? menuId : undefined}
      >
        {buttonLabel}
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        MenuListProps={{ sx: { pt: 0, pb: 0 } }}
      >
        <MenuItem
          onClick={() => {
            handleMenuClose()
            onAddJob()
          }}
        >
          <ListItemText
            primaryTypographyProps={{ fontWeight: 500, variant: "body2" }}
          >
            {addJobLabel}
          </ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleMenuClose()
            onAddSuggestedJobs()
          }}
        >
          <ListItemText
            primaryTypographyProps={{ fontWeight: 500, variant: "body2" }}
          >
            {addSuggestedLabel}
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}

export default AddJobMenu
